import styled from 'styled-components'

export const SectionRoot = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  min-width: 0;
  animation: analyticsSectionReveal 0.36s ease both;

  @keyframes analyticsSectionReveal {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @media (prefers-reduced-motion: reduce) { animation: none; }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${p => p.three ? 'repeat(3, minmax(0, 1fr))' : 'minmax(0, 1.55fr) minmax(300px, 0.8fr)'};
  gap: clamp(24px, 4vw, 54px);

  @media (max-width: 1040px) { grid-template-columns: ${p => p.three ? 'repeat(2, minmax(0, 1fr))' : '1fr'}; gap: 0 30px; }
  @media (max-width: 700px) { grid-template-columns: 1fr; gap: 0; }
`

export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: clamp(24px, 4vw, 54px);
  @media (max-width: 840px) { grid-template-columns: 1fr; gap: 0; }
`

export const ChartPanel = styled.section`
  min-width: 0;
  padding: 26px 0 30px;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
`

export const TablePanel = styled(ChartPanel)`
  overflow: hidden;

  .MuiTableContainer-root {
    max-width: 100%;
    overflow-x: auto;
  }
`

export const PanelHeader = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 20px;
`

export const PanelTitle = styled.h2`
  margin: 0;
  color: ${p => p.theme.palette.colors.text};
  font: 700 19px/1.25 Poppins, sans-serif;
  letter-spacing: -0.02em;
`

export const PanelDescription = styled.p`
  max-width: 700px;
  margin: 6px 0 0;
  color: ${p => p.theme.palette.colors.subdued};
  font: 400 12px/1.55 Poppins, sans-serif;
`

export const Ranking = styled.ol`
  display: grid;
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
`

export const RankingItem = styled.li`
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 12px;
  padding: 13px 0;
  border-top: 1px solid ${p => p.theme.palette.colors.borderSoft};

  > span { color: ${p => p.theme.palette.colors.subdued}; font: 600 11px/1.6 Poppins, sans-serif; }
`

export const RankingTitle = styled.h3`
  overflow: hidden;
  margin: 0;
  color: ${p => p.theme.palette.colors.text};
  font: 600 13px/1.5 Poppins, sans-serif;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const RankingMeta = styled.p`
  margin: 3px 0 0;
  color: ${p => p.theme.palette.colors.subdued};
  font: 500 11px/1.45 Poppins, sans-serif;
`
